import { component } from 'picoapp';
import Drawer from '../../js/utils/drawer';
import { repaint } from '../../js/utils/node';
import Ready from '../../js/utils/ready';
import { hide as hideOverlay, show as showOverlay } from '../../js/utils/overlay';

export default component(async (node, ctx) => {
  /**
   * Elements + data
   */
  const closeBtns = node.querySelectorAll('.js-closeBtn');
  const submenus = node.querySelectorAll('.js-submenu');
  const submenuTriggers = node.querySelectorAll('.js-submenuTrigger');
  const submenuCloseBtns = node.querySelectorAll('.js-submenuCloseBtn');
  const colorSwatches = document.querySelectorAll('.color-swatch');
  const submenuTriggerActiveClass = 'menu__link--active';
  const submenuActiveClass = 'menu__submenu--active';

  /**
   * Functions
   */
  const closeSubmenu = (submenu) => {
    const trigger = Array.from(submenuTriggers).find((t) => (
      t.dataset.title === submenu.dataset.title
    ));

    const indicator = trigger.querySelector('.js-indicator');

    trigger.classList.remove(submenuTriggerActiveClass);
    indicator.innerHTML = window.theme.templates.icons.plus;

    submenu.classList.remove(submenuActiveClass);

    const transitionDuration = parseFloat(getComputedStyle(submenu).getPropertyValue('transition-duration') || 0, 10);

    if (transitionDuration <= 0) {
      submenu.hidden = true;
    } else {
      submenu.addEventListener('transitionend', () => {
        if (!submenu.classList.contains(submenuActiveClass)) {
          submenu.hidden = true;
        }
      }, { once: true });
    }
  };

  const openSubmenu = (submenu) => {
    const trigger = Array.from(submenuTriggers).find((t) => (
      t.dataset.title === submenu.dataset.title
    ));

    const indicator = trigger.querySelector('.js-indicator');

    trigger.classList.remove(submenuTriggerActiveClass);
    indicator.innerHTML = window.theme.templates.icons.minus;

    trigger.classList.add(submenuTriggerActiveClass);

    submenus.forEach((s) => {
      if (s !== submenu) {
        closeSubmenu(s);
      }
    });

    submenu.hidden = false;
    repaint(submenu);
    submenu.classList.add(submenuActiveClass);
  };

  const toggleSubmenu = (submenu) => {
    if (submenu.classList.contains(submenuActiveClass)) {
      closeSubmenu(submenu);
    } else {
      openSubmenu(submenu);
    }
  };

  const initDrawer = () => {
    const drawer = Drawer(node);
    ctx.on('menu:open', () => {
      drawer.open();
      if (document.querySelector('header.header').classList.contains('header--megamenu-open')) {
        document.querySelector('header.header').classList.remove('header--megamenu-open');
      }
      document.querySelectorAll('.header__megamenu').forEach(el => {
        if (el.classList.contains('header__megamenu--active')) {
          el.classList.remove('header__megamenu--active');
        }
      });
      showOverlay();
    } );

    const closeSubmenus = () => {
      submenus.forEach((submenu) => {
        closeSubmenu(submenu);
      });
    };

    drawer.on('close', closeSubmenus);

    closeBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        closeSubmenus();
        drawer.close();
      });
    });
  };

  const initSubmenuTriggers = () => {
    submenuTriggers.forEach((trigger) => {
      const submenu = Array.from(submenus).find((menu) => (
        menu.dataset.title === trigger.dataset.title
      ));

      if (submenu) {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          toggleSubmenu(submenu);
        });
      }
    });
  };


  const initSubmenuCloseBtns = () => {
    submenuCloseBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        const submenu = btn.closest('.js-submenu');
        toggleSubmenu(submenu);
      });
    });
  };

  const initColorSwatches = () => {
    colorSwatches.forEach( (el, i, parent) => {
      el.addEventListener('mouseover', (event) => triggerColorSwatch(el, i, parent, event));
      el.addEventListener('mouseout', (event) => colorSwatchAfterEffect(el, i, parent, event));

    }); 
  }

  const colorSwatchAfterEffect = (el, i, parent, event) => {
    const currProductEl = el.closest(".nav-product__item"); 
    currProductEl.querySelector('[nav_product_item_image]').style.opacity = 1; 
  };

  const triggerColorSwatch = (el, i, parent, event) => {
    event.preventDefault();
    const currSwatchEl = el;
    const currHeaderMegaMenuEl = currSwatchEl.closest('.header__megamenu');

    let dataJsonArr = [];
    let currElementsArr = [];
    const currProductEls = currHeaderMegaMenuEl.querySelectorAll('.nav-product__item[default-product]');
    const currSwatchesWrapper = currSwatchEl.closest('.color-swatches__wrapper');

    currProductEls.forEach(el => {
      el.querySelector('[nav_product_item_image]').style.opacity = 0;
    })

    currSwatchesWrapper.querySelectorAll('div').forEach(el => el.classList.remove('current_tag'));
    currSwatchEl.classList.add('current_tag');
    const currDataTag = el.getAttribute("data-tag");

    const allCurrActiveSwatches = currHeaderMegaMenuEl.querySelectorAll(`[data-tag=${currDataTag}]`);
    allCurrActiveSwatches.forEach(el => {
      dataJsonArr.push(el.getAttribute('data-product-swatch'));
      currElementsArr.push(el);
    });

    try{
      // const dataJson = JSON.parse(getProductData); 

      currProductEls.forEach((currProductEl, index) => {
        if (dataJsonArr[index] === undefined) {
          currProductEl.classList.add('hidden');
          return;
        }

        let currDataJson = JSON.parse(dataJsonArr[index]);
        let currElement = currElementsArr[index];
        // Updating image
        triggerImageUpdateFromByColorSwatch(currProductEl, currElement);

        // Updating price
        currProductEl.querySelector('[nav_product_item_price]').innerText = Shopify.formatMoney(currDataJson?.price, window.theme.moneyFormat);

        // Updating title
        triggerTitleUpdateFromByColorSwatch(currProductEl, currDataJson);

        // Updating handle 
        triggerHandleUpdateFromByColorSwatch(currProductEl, currDataJson);

        // Start color swatch flow
        triggerColorSwatchFlow(currSwatchEl, currHeaderMegaMenuEl, currDataJson)
      })

    }
    catch(ex){
      console.log("error", ex)
    }
    
  };

  const triggerColorSwatchFlow = (currSwatchEl, currHeaderMegaMenuEl, dataJson) => {
    const currColor = currSwatchEl.getAttribute('data-tag');
    triggerProductVisibility(currColor, currHeaderMegaMenuEl);
    triggerHeaderMenuImageFlow(currColor, currHeaderMegaMenuEl, dataJson);
    triggerHeaderMenuButtonFlow(currColor, currHeaderMegaMenuEl, dataJson);
    triggerHeaderMenuTextFlow(currColor, currHeaderMegaMenuEl, dataJson);
  };


  const triggerProductVisibility = (currColor, currHeaderMegaMenuEl) => {
    const allVisibleProducts = currHeaderMegaMenuEl.querySelectorAll('li[product-color-type]');
    allVisibleProducts[0].setAttribute('product-color-type', currColor);
    allVisibleProducts.forEach(function (el) {

      if(currColor !== 'variant-white' && !el.hasAttribute('default-product')){
        el.classList.add('hidden');
      }
      else {
        el.classList.remove('hidden');
      }
    })
  }

  const triggerHeaderMenuImageFlow = (currColor, currHeaderMegaMenuEl, dataJson) => {
    let currMainImage = currHeaderMegaMenuEl.querySelector(`[mega_menu_main_img_wrapper] img.${currColor}`)
    const currActiveImg = currHeaderMegaMenuEl.querySelector('[mega_menu_main_img_wrapper] img.active-img');
    if (currActiveImg !== null) {
      currActiveImg.classList.add('hidden');
      currActiveImg.classList.remove('active-img');
    }
    if (currMainImage !== null) {
      currMainImage.classList.remove('hidden');
      currMainImage.classList.add('active-img'); 
    }
    else {
      currHeaderMegaMenuEl.querySelectorAll('[mega_menu_main_img_wrapper] img').forEach(el => {
        el.classList.add('hidden');
      })
    }
  };

  const triggerHeaderMenuButtonFlow  = (currSwatchEl, currHeaderMegaMenuEl, dataJson) => {
    let currBtn = currHeaderMegaMenuEl.querySelector(`[mega_menu_btn].active-btn`);
    let selectedBtn = currHeaderMegaMenuEl.querySelector(`[mega_menu_btn].${currSwatchEl}`);
    if (currBtn !== null) {
      currBtn.classList.add('hidden');
      currBtn.classList.remove('active-btn');
    }
    if (selectedBtn !== null) {
      selectedBtn.classList.remove('hidden');
      selectedBtn.classList.add('active-btn'); 
    }
    else {
      currHeaderMegaMenuEl.querySelectorAll('[mega_menu_btn]').forEach(el => {
        el.classList.add('hidden');
      })
    }
  };

  const triggerHeaderMenuTextFlow  = (currSwatchEl, currHeaderMegaMenuEl, dataJson) => {
    let currText = currHeaderMegaMenuEl.querySelector(`[mega_menu_text].active-text`);
    let selectedText = currHeaderMegaMenuEl.querySelector(`[mega_menu_text].${currSwatchEl}`);
    if (currText !== null) {
      currText.classList.add('hidden');
      currText.classList.remove('active-text');
    }
    if (selectedText !== null) {
      selectedText.classList.remove('hidden');
      selectedText.classList.add('active-text'); 
    }
    else {
      currSwatchEl.querySelectorAll('[mega_menu_text]').forEach(el => {
        el.classList.add('hidden');
      })
    }
  };

  const triggerImageUpdateFromByColorSwatch = (currProductEl, currSwatchEl) => {
    if(currProductEl == null || currSwatchEl == null ) return;

    const currProductImgWrapper = currProductEl.querySelector('[nav_product_item_image]'); 
    const currProductImg = currSwatchEl.querySelector('img');

    const currProductImgClonned = currProductImg.cloneNode(true);

    currProductImgClonned.classList.remove('hidden');
    currProductImgWrapper.querySelector('img').remove();
    currProductImgWrapper.append(currProductImgClonned);

    currProductEl.querySelector('[nav_product_item_image]').style.opacity = '1';
  };

  const triggerTitleUpdateFromByColorSwatch = (currProductEl, dataJson) => {

    const productColorLabel = currProductEl.querySelector('[nav_product_item_title] > span');
    productColorLabel.classList.add("opacity-0");
      const title = dataJson.title;
      
      if (title.includes('|')) {
        const titleColor = title?.split('|')[1];
        if(titleColor === undefined) return; 
          if(dataJson?.tags !== undefined){
            const detail = dataJson.tags.find(el => el.includes('detail'));
            
            if(detail !== undefined){
              const productDetail = detail.split('-');
              productColorLabel.innerText = productDetail[1];
              productColorLabel.classList.remove("opacity-0");
            }
          }

      }
      else {
        productColorLabel.classList.add("opacity-0");
      }
  };

  const triggerHandleUpdateFromByColorSwatch = (currProductEl, dataJson) => {
    const currProductLink = currProductEl.querySelector('a');
    currProductLink.setAttribute('href', `/products/${dataJson.handle}`);

  };

  const init = () => {
    Ready(() => {
      initDrawer();
      initSubmenuTriggers();
      initSubmenuCloseBtns();
      initColorSwatches();
    });
  };

  /**
   * Init
   */
  init();
});
